module.exports = __webpack_public_path__ + "img/youtube.07736bfb.svg";